module.exports = __webpack_public_path__ + "static/media/sign-up.22721fab.png";